import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const login = (email, password) => {
    return fetch(`${apiUrl}auth/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email,
            password,
        })
    });
}

export default login